// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/grid","root":"grid-m__root__3OPFW","header":"grid-m__header__2iQXg","filterGroup":"grid-m__filterGroup__9e2Ev"};